import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCmRrafKckmFZfSgEi_2YJdYKZq2A-r_pg',
  authDomain: 'nexusai-a5bde.firebaseapp.com',
  projectId: 'nexusai-a5bde',
  storageBucket: 'nexusai-a5bde.firebasestorage.app',
  messagingSenderId: '71869127737',
  appId: '1:71869127737:web:e7bc673ab5d14a6e18c1e8',
  measurementId: 'G-XG5Z4EEWYJ'
};

const app = initializeApp(firebaseConfig);

let analytics;
// Temporarily disable analytics to prevent fetch errors
// (async () => {
//   try {
//     if (await isSupported()) {
//       analytics = getAnalytics(app);
//     }
//   } catch (_) {
//     // analytics not supported in this environment (e.g., server-side or without cookies)
//   }
// })();

export { app, analytics };
